import { clearUserIdentityCache } from 'shared/administration/api/identity'
import { resetOrganizationMembership } from 'shared/api/organizationSession'
import { captureException } from 'shared/helpers/captureException'

import { logout, requestLoginToken, verifyLoginToken } from 'api/authApi'
import { setVerifyRequestIsInitiated } from '../../../pages/Registration/VerifyCode/VerifyCode'
import { ReduxDispatch } from '../../store/models'
import * as apiActions from '../apiStatus/actions'
import * as actionTypes from './authActionTypes'

export const forceClientLogout = () => {
  clearUserIdentityCache()
  localStorage.removeItem('isAuthenticated')
  return { type: actionTypes.LOGOUT_USER }
}

export const setUserContact = (contact: string) => ({
  type: actionTypes.SET_USER_CONTACT,
  contact,
})

export const userAuthenticationSuccess = () => {
  resetOrganizationMembership()
  clearUserIdentityCache()
  return { type: actionTypes.USER_AUTHENTICATION_SUCCESS }
}

export const getLoginToken = (contact: string) => (dispatch: ReduxDispatch) => {
  contact = contact.trim().toLowerCase()
  dispatch(setUserContact(contact))
  dispatch(apiActions.beginApiCall())
  return requestLoginToken(contact)
    .then(() => {
      setVerifyRequestIsInitiated()
      dispatch(apiActions.endApiCall())
    })
    .catch((error) => {
      dispatch(apiActions.endApiCall())
      throw error
    })
}

export const authenticateUser = (loginToken: string, userContact: string) => (dispatch: ReduxDispatch) => {
  dispatch(apiActions.beginApiCall())
  return verifyLoginToken(loginToken, userContact)
    .then(() => {
      dispatch(apiActions.endApiCall())
      dispatch(userAuthenticationSuccess())
    })
    .catch((error) => {
      dispatch(apiActions.endApiCall())
      throw error
    })
}

export const logoutUser = () => (dispatch: ReduxDispatch) => {
  // An expired session or unavailable server must not prevent signing out locally.
  dispatch(forceClientLogout())
  return logout().catch((error) => {
    if (error?.response?.status !== 401) {
      captureException(error, 'logout')
    }
  })
}
